module.exports = __webpack_public_path__ + "static/media/level-debug.7822e85e.glb";